

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

interface EventRequest {
    userId: any,
     messageId: number,
     eventId: number,,
     eventType: any,
     message: any,
}

export interface chatMessageState {
    chatResponse: any | null;
    loading: boolean;
    error: string | null;
    success: boolean | null;
}

export const initialState: chatMessageState = {
    chatResponse: null,
    loading: false,
    error: null,
    success: false,
};


export const deleteMessage = createAsyncThunk<any, {  payload: EventRequest }, { rejectValue: string }>(
    '/api/chats/ws/delete',
    async ({  payload }, { rejectWithValue }) => {
        try {
            const axiosResponse = await axios.post<any>(`/api/chats/ws/delete`, payload);
            return axiosResponse.data;
        } catch (error) {
            throw rejectWithValue(error.response?.data?.message || 'An error occurred');
        }
    }
);


export const chatDeleteSlice = createSlice({
    name: 'chatDeleteReducer',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(deleteMessage.pending, state => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(deleteMessage.fulfilled, (state, action) => {
                state.chatResponse = action.payload
                state.loading = false;
                state.error = null;
                state.success = true;
            })
            .addCase(deleteMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
                state.success = false;
            })
    },
});

export default chatDeleteSlice.reducer;
